import { enableProdMode, provideCheckNoChangesConfig, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Stale-view check for local debugging; set to true and rebuild to use it. Off by default because it adds a check pass
// every second. In development builds it checks attached views, OnPush ones included, for binding values that changed
// without being rendered, and reports each as NG0100 naming the component: a screen that did not update. Angular drops
// it from optimized builds, so it never reaches deployed environments.
const enableStaleViewCheck = false;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [
    provideZoneChangeDetection(),
    ...(enableStaleViewCheck ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })] : []),
  ],
})
  .catch(err => console.error(err));
